module.exports = __webpack_public_path__ + "cb16f131581d756289f6de24ae0eb797.svg";